import { useEffect } from "react";
import { RECEIVE_RANDOM, RandomPayload } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitRandomActions } from "./toolkitRandomStore";

export function useToolkitRandomRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== RECEIVE_RANDOM) {
        return;
      }

      toolkitRandomActions.receiveRandom(action.payload as RandomPayload);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
